/**
 * @ignore  =====================================================================================
 * @fileoverview vuex的mutationType统一管理
 * @author  devinzhong@outlook.com
 * @version 0.4.0
 * @ignore  created in 2016-8-25
 * @ignore  =====================================================================================
 */

const mutationTypes = {

  // 初始化基本数据信息
  INIT_BASE_DATA: 'INIT_BASE_DATA',

  // 添加、更新或删除state内容
  REFRESH_STATE: 'REFRESH_STATE',
}


// 导出类型
export default mutationTypes



/** WEBPACK FOOTER **
 ** ./src/vuex/mutation-types.js
 **/